import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequestModel } from 'src/app/models/requests';

@Component({
  selector: 'app-performactioncertificates',
  templateUrl: './performactioncertificates.component.html'
})
export class PerformactioncertificatesComponent implements OnInit {

  @Input('certificates') certificates!: any;
  @Input('request') request!: RequestModel;
  @Output('close') close = new EventEmitter();
  certificateToUse: any;
  selectedCertificate: any;

  constructor(public activeModal: NgbActiveModal) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  back() {
    this.activeModal.close();
  }

  selectCertificate() {
    if (this.certificateToUse) {
      this.activeModal.close();
      this.close.emit(this.certificateToUse);
    }
  }

  updateCertificate(cert: any) {
    this.certificateToUse = cert;
  }
}
